(function () {
  if (window.__knBulletsCardsInit) return;
  window.__knBulletsCardsInit = true;

  var ICONS = {
    warm:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 2.5c-1 3-3.5 4-3.5 7.5 0 2 1 3 1.5 4-1-0.5-1.5-1.5-1.5-2.5C6.5 13.5 5 16 5 18a7 7 0 0 0 14 0c0-3-2-5-3.5-7 0 1.2-0.5 2-1.5 2 1-2.5 0.8-5.2-2-10.5z" fill="currentColor" fill-opacity="0.24"/>' +
      '<path d="M12 14c-1 1-1.5 2-1.5 3a1.5 1.5 0 0 0 3 0c0-0.7-0.4-1.3-1-2" fill="currentColor" fill-opacity="0.55" stroke="none"/>' +
      '</svg>',
    iceheat:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="7" fill="currentColor" fill-opacity="0.2"/>' +
      '<path d="M12 5v14M5 12h14M7.5 7.5l9 9M16.5 7.5l-9 9" stroke-width="1.4" opacity="0.65"/>' +
      '<path d="M10.5 5.2 12 6.6 13.5 5.2M10.5 18.8 12 17.4 13.5 18.8M5.2 10.5 6.6 12 5.2 13.5M18.8 10.5 17.4 12 18.8 13.5" stroke-width="1.2" opacity="0.55"/>' +
      '<circle cx="12" cy="12" r="2.4" fill="currentColor" stroke="none" fill-opacity="0.85"/>' +
      '</svg>',
    ice:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="5" fill="currentColor" fill-opacity="0.2" stroke="none"/>' +
      '<line x1="12" y1="2.5" x2="12" y2="21.5"/>' +
      '<line x1="3.8" y1="7.2" x2="20.2" y2="16.8"/>' +
      '<line x1="20.2" y1="7.2" x2="3.8" y2="16.8"/>' +
      '<polyline points="9.6 5.2 12 7.6 14.4 5.2" stroke-width="1.5"/>' +
      '<polyline points="9.6 18.8 12 16.4 14.4 18.8" stroke-width="1.5"/>' +
      '<polyline points="5.2 9.6 7.6 12 5.2 14.4" stroke-width="1.5"/>' +
      '<polyline points="18.8 9.6 16.4 12 18.8 14.4" stroke-width="1.5"/>' +
      '</svg>',
    sun:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="4.2" fill="currentColor" fill-opacity="0.24"/>' +
      '<line x1="12" y1="2" x2="12" y2="4.6"/>' +
      '<line x1="12" y1="19.4" x2="12" y2="22"/>' +
      '<line x1="2" y1="12" x2="4.6" y2="12"/>' +
      '<line x1="19.4" y1="12" x2="22" y2="12"/>' +
      '<line x1="4.93" y1="4.93" x2="6.7" y2="6.7"/>' +
      '<line x1="17.3" y1="17.3" x2="19.07" y2="19.07"/>' +
      '<line x1="4.93" y1="19.07" x2="6.7" y2="17.3"/>' +
      '<line x1="17.3" y1="6.7" x2="19.07" y2="4.93"/>' +
      '</svg>',
    moon:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="currentColor" fill-opacity="0.22"/>' +
      '<path d="M16 6.5l1 1.6 1.8 0.2-1.3 1.2 0.3 1.7L16 10.4l-1.6 0.8 0.3-1.7-1.3-1.2 1.8-0.2z" fill="currentColor" stroke="none" fill-opacity="0.8"/>' +
      '</svg>',
    sunrise:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="13" r="3.2" fill="currentColor" fill-opacity="0.22"/>' +
      '<path d="M17 18a5 5 0 0 0-10 0"/><path d="M2 18h20"/><path d="M12 3v6"/><path d="m4.22 10.22 1.42 1.42"/><path d="m18.36 11.64 1.42-1.42"/><path d="M9 6l3-3 3 3"/>' +
      '</svg>',
    compression:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<rect x="7.5" y="3.5" width="9" height="17" rx="4.5" fill="currentColor" fill-opacity="0.22"/>' +
      '<path d="M9 9.5h6M9 12h6M9 14.5h6" stroke-width="1.4" opacity="0.75"/>' +
      '<path d="M3.2 12h3.3M5 10.2 6.5 12 5 13.8" stroke-width="2"/>' +
      '<path d="M20.8 12h-3.3M19 10.2 17.5 12 19 13.8" stroke-width="2"/>' +
      '</svg>',
    heart:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="currentColor" fill-opacity="0.24"/>' +
      '<path d="M8.8 12c0.5 1.4 1.8 2.4 3.2 2.4s2.7-1 3.2-2.4" stroke-width="1.6" fill="none"/>' +
      '<circle cx="9.8" cy="9.5" r="0.75" fill="currentColor" stroke="none"/>' +
      '<circle cx="14.2" cy="9.5" r="0.75" fill="currentColor" stroke="none"/>' +
      '</svg>',
    droplet:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 3 C 12 3, 5 11, 5 15 A 7 7 0 0 0 19 15 C 19 11, 12 3, 12 3 Z" fill="currentColor" fill-opacity="0.24"/>' +
      '<path d="M9 15a3 3 0 0 0 3 3" stroke-width="1.6" fill="none"/>' +
      '<circle cx="14.5" cy="10.5" r="1.2" fill="currentColor" stroke="none" fill-opacity="0.7"/>' +
      '</svg>',
    feather:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z" fill="currentColor" fill-opacity="0.22"/>' +
      '<line x1="16" y1="8" x2="2" y2="22"/><line x1="17.5" y1="15" x2="9" y2="15"/>' +
      '</svg>',
    leaf:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M11 20A7 7 0 0 1 4 13C4 7 11 4 21 3c-1 10-4 17-10 17z" fill="currentColor" fill-opacity="0.22"/>' +
      '<path d="M2 21c0-3 1.85-5.36 5.08-6"/>' +
      '</svg>',
    check:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="10" fill="currentColor" fill-opacity="0.18" stroke-width="0"/>' +
      '<path d="M7 12l3.5 3.5L17 9"/>' +
      '</svg>'
  };

  var ICON_CLASS_MAP = {
    'kn-heroclaims__check--moon': 'moon',
    'kn-heroclaims__check--sunrise': 'sunrise',
    'kn-heroclaims__check--compression': 'compression',
    'kn-heroclaims__check--heart': 'heart',
    'kn-heroclaims__check--droplet': 'droplet',
    'kn-heroclaims__check--feather': 'feather',
    'kn-heroclaims__check--leaf': 'leaf',
    'kn-heroclaims__check--check': 'check'
  };

  function detectIcon(li) {
    var checkSpan = li.querySelector('.kn-heroclaims__check');
    if (!checkSpan) return 'check';
    for (var cls in ICON_CLASS_MAP) {
      if (checkSpan.classList.contains(cls)) return ICON_CLASS_MAP[cls];
    }
    var bcardIco = li.querySelector('.kn-bcard__ico');
    if (bcardIco) {
      for (var i = 0; i < bcardIco.classList.length; i++) {
        var c = bcardIco.classList[i];
        var m = c.match(/^kn-bcard__ico--(.+)$/);
        if (m && ICONS[m[1]]) return m[1];
      }
    }
    return 'check';
  }

  function parseExistingCard(card) {
    var titleEl = card.querySelector('.kn-bcard__title');
    var subEl = card.querySelector('.kn-bcard__sub');
    return {
      icon: detectIcon(card),
      title: titleEl ? titleEl.textContent.trim() : '',
      sub: subEl ? subEl.textContent.trim() : ''
    };
  }

  function parseLi(li) {
    var textEl = li.querySelector('.kn-heroclaims__text');
    var raw = textEl ? textEl.innerHTML.trim() : li.textContent.trim();
    var icon = detectIcon(li);
    var prefixMatch = raw.match(/^\s*\[([a-z]+)\]\s*/i);
    if (prefixMatch) {
      var token = prefixMatch[1].toLowerCase();
      if (ICONS[token]) icon = token;
      raw = raw.slice(prefixMatch[0].length);
    }
    raw = raw.replace(/\[([a-z]+)\]/gi, '').trim();
    var title = raw;
    var sub = '';
    if (raw.indexOf('||') !== -1) {
      var parts = raw.split('||');
      title = parts[0].trim();
      sub = parts.slice(1).join('||').trim();
    }
    return { icon: icon, title: title, sub: sub };
  }

  function buildCardHtml(c) {
    var iconSvg = ICONS[c.icon] || ICONS.check;
    return (
      '<div class="kn-bcard">' +
      '<span class="kn-bcard__ico kn-bcard__ico--' + c.icon + '" aria-hidden="true">' +
      iconSvg +
      '</span>' +
      '<div class="kn-bcard__body">' +
      '<div class="kn-bcard__title">' + c.title + '</div>' +
      (c.sub ? '<div class="kn-bcard__sub">' + c.sub + '</div>' : '') +
      '</div>' +
      '</div>'
    );
  }

  function transformBlock(block) {
    if (block.dataset.knCardsApplied === '1') return;

    var items = [];
    var existingCards = block.querySelectorAll('.kn-bcard');
    if (existingCards.length) {
      existingCards.forEach(function (card) { items.push(parseExistingCard(card)); });
    } else {
      var lis = block.querySelectorAll('li');
      if (!lis.length) return;
      lis.forEach(function (li) { items.push(parseLi(li)); });
    }

    if (!items.length) return;

    block.classList.add('kn-bullets-grid');
    block.innerHTML = items.map(buildCardHtml).join('');
    block.dataset.knCardsApplied = '1';
  }

  function render() {
    document.querySelectorAll('.kn-bullets-block').forEach(transformBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.kn-bullets-block').forEach(function (b) {
      b.dataset.knCardsApplied = '';
    });
    render();
  });
  setTimeout(render, 400);
  setTimeout(render, 1500);
})();
